export const MARKETING_FORM_CAMPAIGN = "marketing_form_campaign";
